import { render, staticRenderFns } from "./ModalAppr.vue?vue&type=template&id=de331736&scoped=true&"
import script from "./ModalAppr.vue?vue&type=script&lang=js&"
export * from "./ModalAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de331736",
  null
  
)

export default component.exports